import { COLOR_BUTTON_DISABLED, COLOR_GREEN, COLOR_WH } from '../colors.constants';

export const colorsSwitch = {
  colorSwitch: COLOR_BUTTON_DISABLED,
  colorSwitchActive: COLOR_GREEN,
  colorSwitchThumb: COLOR_WH,
};
